
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface SaveSimulationDialogData {
  title: string;
  name: string;
  description?: string;
}

@Component({
  selector: 'app-save-simulation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule
  ],
  template: `
    <div class="dialog-container">
        <!-- Close Button -->
        <!-- <button class="close-btn" (click)="onCancel()">×</button> -->

        <div class="dialog-content-wrapper">
             <div class="input-row">
                <div class="label-box">Name</div>
                <div class="input-box">
                    <input type="text" [(ngModel)]="data.name" placeholder="Enter name..." />
                </div>
             </div>
             <div class="input-row">
                <div class="label-box">Description</div>
                <div class="input-box">
                     <input type="text" [(ngModel)]="data.description" placeholder="Enter description..." />
                </div>
             </div>
        </div>

        <div class="dialog-actions">
             <button class="btn-reset" (click)="onReset()">Reset</button>
             <span class="save-btn-wrapper"
               [matTooltip]="isSaveDisabled ? 'Name and description both required' : ''"
               [matTooltipDisabled]="!isSaveDisabled"
               matTooltipPosition="above">
               <button class="btn-save" [disabled]="isSaveDisabled" (click)="onSave()">Save</button>
             </span>
        </div>
    </div>
  `,
  styles: [`
    .dialog-container {
        padding: 20px;
        background: white;
        border-radius: 8px; /* Optional rounded corners */
        width: 100%; /* Adjust width as needed */
        box-sizing: border-box;
        position: relative;
        font-family: sans-serif;
    }
    .dialog-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 2px; /* Small gap between rows */
        margin-bottom: 20px;
        border: 1px solid #ccc; /* Outer border */
    }
    .input-row {
        display: flex;
        border-bottom: 1px solid #ccc;
    }
    .input-row:last-child {
        border-bottom: none;
    }
    .label-box {
        width: 120px;
        background-color: #444; /* Dark background */
        color: white;
        padding: 10px;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 14px;
    }
    .input-box {
        flex: 1;
        background-color: #f0f0f0; /* Light grey background */
        padding: 0;
    }
    .input-box input {
        width: 100%;
        height: 100%;
        border: none;
        background: transparent;
        padding: 10px;
        font-size: 14px;
        outline: none;
        font-weight: bold; /* Match the bold text in screenshot */
    }
    .dialog-actions {
        display: flex;
        justify-content: center; /* Center buttons */
        gap: 20px;
    }
    .btn-reset, .btn-save {
        padding: 8px 30px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
        color: white;
        font-size: 14px;
    }
    .btn-reset {
        background-color: #999; /* Grey */
    }
    .btn-save {
        background-color: #a81c07; /* Red/Brown */
    }
    .btn-save:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
    .save-btn-wrapper {
        display: inline-block;
    }
  `]
})
export class SaveSimulationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SaveSimulationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveSimulationDialogData
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onReset(): void {
    this.data.name = '';
    this.data.description = '';
  }

  get isSaveDisabled(): boolean {
    return this.isEmpty(this.data?.name) || this.isEmpty(this.data?.description);
  }

  private isEmpty(value?: string): boolean {
    return !value || value.trim().length === 0;
  }

  onSave(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.dialogRef.close({
      name: this.data.name.trim(),
      description: (this.data.description || '').trim()
    });
  }
}
